import React, { useCallback, useEffect, useState } from 'react';
import { initializeEvaluation } from '../../../services/ExpertReviewService';
import SmashLoader from '../../Loader/SmashLoader';

export default function SummaryPage({ sessionId, videoSrc }) {
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(
    (signal) => {
      setError(null);
      setIsLoading(true);
      initializeEvaluation(sessionId)
        .then(() => setSubmitted(true))
        .catch((requestError) => {
          if (signal?.aborted) return;
          setError(
            requestError.response?.data?.detail ||
              'We could not submit the interview for evaluation.',
          );
        })
        .finally(() => {
          if (signal?.aborted) return;
          setIsLoading(false);
        });
    },
    [sessionId],
  );

  useEffect(() => {
    const controller = new AbortController();
    fetchData(controller.signal);
    return () => controller.abort();
  }, [fetchData]);

  if (isLoading) return <SmashLoader description="Loading summary" />;
  if (error) return (
    <div role="alert" className="mx-auto max-w-xl rounded-xl border border-red-200 bg-red-50 p-5 text-center text-red-800">
      <p>{error}</p>
      <button type="button" onClick={() => fetchData()} className="mt-3 rounded-lg bg-red-700 px-4 py-2 font-medium text-white">
        Try submission again
      </button>
    </div>
  );

  return (
    <div className="max-w-3xl mx-auto p-6 space-y-6 w-full">
      <div className="w-full aspect-[16/9] bg-gray-900 rounded-lg overflow-hidden shadow-lg relative">
        {videoSrc ? (
          <video
            src={videoSrc}
            controls
            autoPlay
            playsInline
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="absolute inset-0 flex flex-col items-center justify-center text-white bg-gray-700 p-4">
            <p className="text-lg text-center select-none">No video provided</p>
          </div>
        )}
      </div>
      <h2 className="text-3xl font-bold dark:text-gray-300 text-center mb-6">
        Interview submitted
      </h2>
      {submitted && (
        <div className="rounded-xl border border-blue-200 bg-blue-50 p-6 text-center text-blue-900">
          Your answers are awaiting human expert review. Only the final approved
          evaluation will be added to your portfolio.
        </div>
      )}
    </div>
  );
}
